import { useCallback } from 'react';
import { useAccount, usePublicClient } from 'wagmi';
import useStore from '../store/rootStore';

export function useWalletNonce() {
  const { address, connector } = useAccount();
  const configChainId = useStore((state) => state.config?.chain.id);
  const publicClient = usePublicClient({ chainId: configChainId });

  const getNonce = useCallback(async () => {
    const walletNonce = useStore.getState().walletData?.n;

    if ((connector?.id === 'io.rabby' || connector?.id === 'rabby') && publicClient && address) {
      console.log('Rabby used');
      if (walletNonce != null && !Number.isNaN(walletNonce)) {
        return walletNonce;
      }
      return await publicClient.getTransactionCount({
        address,
      });
    }
    return undefined;
  }, [connector?.id, publicClient, address]);

  return { getNonce };
}
